import styled from 'styled-components';
import { Link as LinkR } from 'react-router-dom';

export const PressContainer = styled.div`
    background: #d3d3d3;
    position: relative;
    height: 100vh;
    overflow: hidden;
    padding-top: 100px;

    @media screen and (min-height: 1200px) {
        height: 75vh;
    }

    @media screen and (max-height: 1060px) {
        height: 130vh;
    }

    @media screen and (max-height: 820px) {
        height: 200vh;
    }

    @media screen and (max-height: 530px) {
        height: 270vh;
    }

    @media screen and (max-height: 395px) {
        height: 400vh;
    }

    @media screen and (max-width: 480px) {
        height: 270vh;
        padding-bottom: 8rem;
    }

`

export const TitleWrapper = styled.div`
    width: 100%;
    max-width: 300px;
    margin: 0 auto;
    margin-top: 3rem;
    text-align: center;
    padding-bottom: 1rem;
    border-bottom: 2px solid black;

    @media screen and (max-width: 480px) {
		max-width: 270px;
	}

    @media screen and (max-width: 370px) {
        max-width: 200px;
        margin-top: 2rem;
    }
`

export const Title = styled.h1`
    font-size: 2.3rem;
    font-weight: bold;

    @media screen and (max-width: 480px) {
		font-size: 1.8rem;
		text-align: center;
	}

    @media screen and (max-width: 370px) {
        font-size: 1.5rem;
    }
`

// export const PressWrapper = styled.div`
//     position: relative;
//     margin: 0 auto;
//     padding: 0 24px;
//     height: 100%;
//     max-width: 1400px;
//     align-items: center;
// `

export const PressWrapper = styled.div`
    position: relative;
    display: grid;
    margin: 0 auto;
    padding: 0 24px;
    max-width: 1400px;
    align-items: center;
    grid-template-columns: 1fr 1fr;
    flex-direction: column;

    @media screen and (max-width: 480px) {
        display: flex;
    }
`

export const C1 = styled.div`
    grid-column-start: 1;
    grid-column-end: 1;
    ${'' /* max-width: 650px; */}
    margin-top: -4rem;

    @media screen and (min-height: 1200px) {
        margin-top: -9rem;
    }

    @media screen and (max-width: 480px) {
        margin-top: 0;
    }

    
`

export const C2 = styled.div`
    grid-column-start: 2;
    grid-column-end: 2;
    ${'' /* max-width: 650px; */}

    ${'' /* @media screen and (max-width: 480px) {
        grid-column-start: 1;
        max-width: 450px;
    } */}
`

export const ReleaseWrapper = styled.div`
    display: block;
    padding-bottom: 2rem;
    margin-top: 3rem;
`

export const Header = styled.h1`
    font-size: 24px;
    font-weight: bold;
    color: #000000;
    padding-bottom: .5rem;
`

export const Subheader = styled.h3`
    font-size: 18px;
    color: #000000;
    margin-top: 2rem;
    margin-left: 2rem;
`

export const Button = styled(LinkR)`
    font-size: 16px;
    color: #2f8eed;
    text-decoration: none;
    transition: all 0.2s ease-in-out;

    &:hover {
        color: #000000;
        transition: all 0.3s ease-in-out;
    }
`